<cl-dialogue
    [titleText]="'User Profile - ' + environment + ' environment'"
    [primaryButtonText]="'Close'"
    (primaryButtonClicked)="close()"
    (closed)="close()"
    [width]="500"
>
    <div class="list-container view-container m20">
        <div class="view-scroll">
            <table class="table">
                <caption></caption>
                <thead>
                    <tr>
                        <th scope="col" class="flag-col">Feature flag</th>
                        <th scope="col">
                            <div class="flex-row">
                                <div class="mr10">Status</div>
                                <div
                                    class="v-icon v-icon-clipboard_full link"
                                    title="Copy all flags to clipboard"
                                    (click)="copyFeatureFlagsToClipboard()"
                                    onkeypress=""
                                ></div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    @for (flag of featureFlags; track flag) {
                        <tr>
                            <td>{{ flag.flag }}</td>
                            <td>{{ flag.enabled ? 'Enabled' : '' }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    @if (isSignalREnabled()) {
        <div class="m10">
            <strong>Real-time notifictions</strong>
        </div>
        <pd-signalr-status></pd-signalr-status>
    }
</cl-dialogue>
